/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OptimizerRunRequest } from '../../models/optimizer-run-request';
import { OptimizerRunResponse } from '../../models/optimizer-run-response';

export interface CreateOptimizerRun$Params {
  location_id: string;
  
    /**
     * Planning horizon of the run
     */
    body: OptimizerRunRequest
}

export function createOptimizerRun(http: HttpClient, rootUrl: string, params: CreateOptimizerRun$Params, context?: HttpContext): Observable<StrictHttpResponse<OptimizerRunResponse>> {
  const rb = new RequestBuilder(rootUrl, createOptimizerRun.PATH, 'post');
  if (params) {
    rb.path('location_id', params.location_id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<OptimizerRunResponse>;
    })
  );
}

createOptimizerRun.PATH = '/locations/{location_id}/optimizer/runs';
